<template>
  <div class="page" >
 <studentCard style="display: none;" :snCode='data.snCode' :schoolCode='data.schoolCode' :teacher='data.teacher'/>
 <!-- <van-skeleton title  :loading="loading" class="yearbox"> -->



 <div class="title_box">
  
  <div class="title">
      <!-- <van-popover v-model="showPopover"  trigger="click" :actions="yearList" @select="onSelectPopover">
                  <template #reference>
                    <div  >
                      <van-icon name="descending" class="onchangeClass"/>
                    </div>
                  </template>
        </van-popover> -->
    {{ this.data.projectName }}</div>

  <div class="trend_box">
    <div class="trendtitle_box">成绩趋势</div>
    <div ref="trendChart" class="trendChart"></div>
  </div>


  <div class="cardRoll_box">
     <div class="cardRoll_badgetopbox"> 
          <img v-show="finalScoreData.level=='优秀'" src="../../assets/parentImg/优秀.png" width="100%"  alt="">
          <img v-show="finalScoreData.level=='良好'" src="../../assets/parentImg/良好.png" width="100%"  alt="">
          <img v-show="finalScoreData.level=='及格'" src="../../assets/parentImg/及格.png" width="100%"  alt="">
          <img v-show="finalScoreData.level=='不及格'" src="../../assets/parentImg/不及格.png" width="100%"  alt="">
        </div>
    <div class="cardRoll_topbox"> 
        <div class="year_score" >
        <span style="font-size: 9.5vw;">{{finalScoreData.sportTime}}</span>
        <span style="">小时</span>
        <span class="year_status_topbox">{{ parseInt(finalScoreData.sportCount)}}次</span>
        <span  style="color:#dddddd;margin-left:4px"><van-icon name="question-o" /></span>
      </div>

         <div style="color:#ECC843;" class="dfcenter">
              <img src="@/assets/image/奖杯@3x.png" style="margin-right:3px;" width="18" alt="">
              <div>战胜{{TopByCount||'-'}}%的同学</div>
           </div>
        <!-- <div style="font-size: 14px;color: #333;">战胜{{TopByCount||'-'}}%的同学</div> -->
       
    </div>
    <div class="cardRoll_bottombox"> 
      <div class="line"></div>
          <div class="cardRoll_bottombox_card">
         <div class="calendar-top-button">
        <van-icon name="arrow-left" @click="arrowLeft()"/>
        <div class="calendar-top-time" >
          {{ year }}-{{ month + 1 }}
        </div>
        <van-icon name="arrow"  @click="arrowRight()"/>
      </div>
                   <van-calendar
              ref="calendar"
              @select="selectCalendar"
              title=" "
              :poppable="false"
              :show-confirm="false"
              :show-title="false"
              :show-subtitle="false"
              :row-height="40"
              :min-date="minDate"
              :max-date="maxDate"
              :formatter="formatter"
              :style="{ height: '325px' }"
              >

              <!-- <div slot="bottom-info" slot-scope="day">
                <div v-if="+day.bottomInfo>0" class="greenPoint" style="color: #51f803;"><van-icon name="star" /></div>
              </div> -->
              </van-calendar>
              
            <!-- <div class="cardRoll_bottombox_top">
               <div class="cardRoll_bottombox_topleft">{{ BmiData.height||'--' }} <span style="font-size: 16px;">cm</span> </div>
                <div class="cardRoll_bottombox_topright">{{ BmiData.weight||'--' }} <span style="font-size: 16px;">kg</span></div>
            </div>
            <div class="cardRoll_bottombox_bottom"> 
              <div  class="cardRoll_bottombox_bottomtop">
                <div class="cardRoll_bottombox_bottomtopleft">当前BMI</div>
                <div class="cardRoll_bottombox_bottomtopright">
                  123
                  <div class="cardRoll_bottombox_bottomtopright_text">正常</div>
                </div>
              </div>
            </div> -->
          </div>
    </div>
  </div>
</div>


<!-- </van-skeleton> -->

    <!-- <div class="card">
      <div class="card-eachart" ref="physicalStrength"></div>
    </div>
    <div class="card">
      <div class="card-eachart" ref="physicalQuality"></div>
    </div> -->

 <!-- <div class="card">
      <div class="card-eachart" ref="strongWeak"></div>
    </div> -->
 <!-- <div class="card">
      <div class="card-eachart" ref="strongTime"></div>
    </div> -->

       <div class="menu"  style="margin-top: 15px;">

<section class="appeal-list-warp" >
    <div style="font-size: 16px;font-weight: 500;">运动记录</div>
      <div v-if="list.length">
  <van-skeleton title  :loading="loading" style="background-color: #fff;border-radius: 10px;margin: 15px 10px;padding: 15px 10px;">

        <div class="item" v-for="(item, index) of list" :key="index" >

          <div class="item-li">


            
            <div class="item-li-left">
              <div class="timeline-line"></div>
              <!-- <div style="color:#B8B8B8;font-size: 12px;">{{ formatDate(item.testTime, 'MM-DD') }}</div> -->
              <!-- <div style="font-size:15px;font-weight:600;">{{ formatDate(item.testTime, 'hh:mm') }}</div> -->
              <div style="color:#B8B8B8;font-size: 12px;">{{ formatDate(item.testTime, 'hh:mm') }}</div> 
              <div style="color: rgb(46, 139, 211);">{{ item.projectName }}</div>
            </div>
            <div style="width: 2%;"></div>
            <div  class="item-li-right"
            :class="['item-li-right', 'item-li-rightb']"
            >
        
              <div  style="height: 100%;">
              <van-row style="height: 100%;font-size: 12px;">
                  <van-col span="8">
                     <div  class="mileageStyle" >{{item.score ||'--'}}
                       <span style="font-size: 12px;font-weight: 500;margin-left: 2px;">{{item.projectUnit}} </span> 
                     </div>
                    <div>成绩</div>

                  </van-col>
                  <van-col span="6">
                    <div  class="mileageStyle" >{{item.fraction ||'--'}}
                       <!-- <span style="font-size: 12px;font-weight: 500;margin-left: 2px;">分 </span>  -->
                     </div>
                    <div>得分</div>
                  </van-col>
                   <van-col span="8">
                    <div  class="mileageStyle" style="font-size: 19px;font-weight: 600;">{{item.level ||'--'}}
                     </div>
                    <div>等级</div>
                  </van-col>
                  <van-col span="2"  style="margin-top: 18px;font-size: 20px;">
                    <van-icon name="play" />
                  </van-col>
              </van-row>
            </div>
        
            </div>
            <div style="width: 3%;"></div>
          </div>
        </div>
</van-skeleton>

      </div>
      <van-empty v-else description="未查询到成绩数据" image-size="100" />
    </section>
</div>


  </div>
</template>

<script>
import studentCard from "@/components/studentCard.vue";
import VideoDialog from "@/components/VideoDialog.vue";
import Vcalendar from "@/components/Vcalendar.vue";
import {
  getTermInfoList,
  querySingleFitnessEvaluationAnalysis,

  queryPhysicalIntensityAnalysis,
  queryPortraitData,
  getFinishProject
} from '@/api/fitnessReport'
import {
scoreStaBySnCode,
  queryPhysicalFitnessAnalysis,
  queryPhysicalQualityAnalysis,
  getFitnessTestBySnCode
} from '@/api/fitnessReport'
import { getEduYearList} from "@/api/resultReporting.js";
// import { selectStudentActivityList} from "@/api/integralShop.js";
import { selectStudentActivityList} from "@/api/parentHomePage.js";
import { scoreWithOneNewFitness} from "@/api/projectLogBoard.js";
import {selectMonthStatusNewFitness} from "@/api/parentHomePage.js";



import {
  getWgzTest,
  getWgzData,
  getTopByCount
} from '@/api/bodyForging'

import * as echarts from 'echarts'
import moment from 'moment'
// 获取当前年份和月份
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth(); // 月份从 0 开始（0 = 1月，11 = 12月）

// 计算当月第一天（00:00:00）
const minDate = new Date(currentYear, currentMonth, 1);

// 计算当月最后一天（23:59:59）
// 下个月的第 0 天即为本月最后一天
const maxDate = new Date(currentYear, currentMonth + 1, 0, 23, 59, 59);
export default {
  components: {
    studentCard,
    VideoDialog,
    Vcalendar
  },
data () {
  return {
    yearList:[],
    showPopover:false,
    ratevalue:5,
    active:0,
    loading:true,
    termCode:'',
    termName:'',
    data:{},
    list:[{
      projectName:'身高体重'
    },
    {
      projectName:'身高体重'
    },
    {
      projectName:'身高体重'
    }],
    finalScoreData:{},
    projectScoreList:[],
    fitnessTestData:[],
    TopByCount:0,
    minDate: minDate,
    maxDate: maxDate,
    today: new Date(), // 设置当前日期
    list:[],
    
    selectDay:moment(new Date()).format('YYYY-MM-DD'),
    monthStatusNewFitnessList:[],
   year:currentDate.getFullYear(),
    month:currentDate.getMonth(),
  }
},
created () {
  let storageData = JSON.parse(sessionStorage.getItem('studentTitleCard'))
  this.data = {
    snCode:storageData.snCode,
    schoolCode:storageData.schoolCode,
    projectName:this.$route.query.projectName,
    projectCode:this.$route.query.projectCode,
  }

//   adminClassId: "class-20231011000012"
// adminClassName: "凤凰研究院班"
// birthDay: "1997-06-01"
// content: null
// id: "stu-2024040900000000002"
// schoolCode: "LMWZ"
// schoolName: "龙猫小学"
// sex: null
// snCode: "18226351321"
// status: "1"
// studentGrade: "16"
// studentGradeName: "小学六年级"
// studentName: "杨森"
// text: "杨森"
},
async mounted () {
  await this.getEduYearList()
  this.init()
  this.selectStudentActivityList()
  // this.queryPhysicalFitnessAnalysis()
  // this.queryPhysicalQualityAnalysis()
  // this.queryPhysicalIntensityAnalysis()
  this.scoreWithOneNewFitness()
  this.selectMonthStatusNewFitness()
},
methods: {
     setminDatemaxDate(month) {
      //计算传入的月份天数
      const daycount = new Date(this.year, month + 1, 0).getDate()
      //将1号设置成可选择最小日期
      let monthMin = new Date(this.year, month, 1)
      //将传入月份的最后一天设置成可选择最大日期
      let monthMax = new Date(this.year, month, daycount)
      //已在setup中初始化minDate和maxDate（minDate=ref()）
      this.minDate = monthMin
      this.maxDate = monthMax
    },
async arrowRight(){
  if (this.month==11) {
    return
  }
  if (this.month== currentDate.getMonth()) {
    return
  }
this.month++
this.setminDatemaxDate(this.month)
await this.selectMonthStatusNewFitness()
// this.$refs.calendar.reset()
},
async arrowLeft(){
  if (this.month==0) {
    return
  }
this.month--
this.setminDatemaxDate(this.month)
await this.selectMonthStatusNewFitness()
// this.$refs.calendar.reset()

},

   formatter(day) {
      // const month = day.date.getMonth() + 1;
      const date = day.date.getDate();
      // if (month === 5) {
      //   if (date === 1) {
      //     day.topInfo = '劳动节';
      //   } else if (date === 4) {
      //     day.topInfo = '青年节';
      //   } else if (date === 11) {
      //     day.text = '今天';
      //   }
      // }
     let month = this.month + 1
     if (month<10) {
      month= '0'+month
     }
      this.monthStatusNewFitnessList?.forEach(item=>{
        // console.log("item.day ",this.formatDate(day.date,'MM'),this.formatDate(day.date,'MM')==this.formatDate(this.today,'MM'));
        
         if (this.formatDate(day.date,'MM')==month) {
        // console.log("item.day ",this.formatDate(day.date,'yyyy-MM-DD') );
        if(item.day == this.formatDate(day.date,'yyyy-MM-DD')&&item.num>0){
          day.num = item.num
          day.className = "green-flag"
        }
      
        
        
      
        // if (day.bottomInfo>0) {
        //   day.className = "green-flag"
        // }



        }
        

      })
      // console.log(this.formatDate(day.date,'yyyy-MM-DD'),this.istoDay(this.formatDate(day.date,'yyyy-MM-DD')),day);
      
      //  if (this.istoDay(this.formatDate(day.date,'yyyy-MM-DD'))&&(!day.num||day.num==0)) {
      //     day.className = "red-flag"
      //   }

      return day;
    },
 async selectMonthStatusNewFitness(){
    let month = +this.month + 1
    if(month<10){
      month = '0' + month
    }
    let monthdata = this.year + '-' +  month
   await selectMonthStatusNewFitness({
      projectCode:this.$route.query.projectCode,
      snCode:this.data.snCode,
      schoolCode:this.data.schoolCode,
      termCode:this.termCode,
      month:monthdata
    }).then(res=>{ 
      console.log('selectMonthStatusNewFitness',res);
      this.monthStatusNewFitnessList = res.data.body
    })
  },
  formatDate(datestr = new Date(), formart = 'yyyy年MM月DD日') {
    return moment(datestr).format(formart);
},
  selectCalendar(value){
    let time= moment(value).format('YYYY-MM-DD')
    console.log('time',time);
    this.selectDay = time
    this.selectStudentActivityList()
  },
scoreWithOneNewFitness(){
scoreWithOneNewFitness({
    snCode:this.data.snCode,
              schoolCode:this.data.schoolCode,
              termCode:this.termCode,
              projectCode:this.$route.query.projectCode,
}).then(res=>{
  console.log('scoreWithOneNewFitness',res.data.body);
  let timeData = []
  let numData = []
  res.data.body?.forEach(el=>{
    timeData.push(el.testTime)
    numData.push(el.score)
  })

  this.gettrendChart(numData,timeData)

})
},
  // 成绩趋势
     gettrendChart(numData,timeData) {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(this.$refs.trendChart)
        let option = {
          color:'#0170ed',
           visualMap: [
           
              {
                show: false,
                type: 'continuous',
                seriesIndex: 1,
                dimension: 0,
                min: 0,
                max: timeData.length - 1
              }
            ],
            title: {
          textStyle: {
            fontSize: 16,
            fontWeight: 500
          }
        },
     
        // radar: {
        //   center: ['50%', '60%'],
        //   radius: 100 // 雷达图缩放大小
        // },
          tooltip: {
    trigger: 'axis'
  },
                        xAxis: {
                          type: 'category',
                          data: timeData,
                          boundaryGap: false,
               axisLabel: {
		          interval: 0,  
		          formatter:function(value)  
		          {  
                console.log(value);
                
		           return moment(value).format('MM/DD');  
		          }  
		      },
   
                        },
                        
                        yAxis: {
                          type: 'value',
                                   splitLine: {
      show: false
    }
                        },
                          dataZoom: [
                          {
                            type: 'inside',
                            start: 0,
                            end: 15
                          },
                          {
                            start: 0,
                            end: 15
                          }
                        ],
                        series: [
                          {
                            data: numData,
                            type: 'line',
                            smooth: true,
                               areaStyle: {
                              opacity: 0.8,
                              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                  offset: 0,
                                  color: 'rgb(9, 106, 252)'
                                },
                                {
                                  offset: 1,
                                  color: '#fff'
                                }
                              ])
                            },
                            // showSymbol: false,
                          }
                        ]
                      };

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
        window.addEventListener("resize",function(){
            myChart.resize();
        });
    },
 // 查询学年
 async getEduYearList(){
 await getEduYearList({
            snCode:this.data.snCode,
            schoolCode:this.data.schoolCode,
          }).then(res=>{  
            res.data.data?.forEach(el=>{
                  el.text = el.name
              if(+el.isActive==1){
                  this.termCode = el.code
                  this.termName = el.name
              }
            })
            this.yearList = res.data.data

            
          })
 },
      // 切换学年
      onSelectPopover(action){
        console.log(action);
         this.termCode = action.code
         this.termName = action.name
         this.init()
         this.selectStudentActivityList()

      },
      async queryPhysicalFitnessAnalysis () {
      const legend = []
      let indicator = []
      let series = []
      await queryPhysicalFitnessAnalysis({
        schoolCode: this.data.schoolCode,
        snCode: this.data.snCode
      }).then((data) => {
        const body = data.data.body
        console.log('body ', body)
        series = body?.series
        indicator = body?.indicator
        series.map((item) => {
          const name = item.name || ''
          legend.push(name)
        })
      })
      this.getPhysicalStrength(legend, indicator, series)
    },
   async queryPhysicalQualityAnalysis () {
      const legend = []
      let indicator = []
      let series = []
      await queryPhysicalQualityAnalysis({
         schoolCode: this.data.schoolCode,
        snCode: this.data.snCode
      }).then((data) => {
        const body = data.data.body
        series = body?.series
        indicator = body?.indicator
        series.map((item) => {
          const name = item.name || ''
          legend.push(name)
        })
      })
      this.$nextTick(() => {
      this.getPhysicalQuality(legend, indicator, series)
      })
    },
    getPhysicalQuality (legend, indicator, series) {
      const myChart = echarts.init(this.$refs.physicalQuality)
      const option = {
        title: {
          text: '身体素质分析',
          textStyle: {
            fontSize: 16,
            fontWeight: 500
          }
        },
        legend: {
          data: legend,
          left: 'right',
          top: 0,
          orient: 'vertical'
        },
        radar: {
          indicator: indicator,
          center: ['50%', '60%'],
          radius: 100 // 雷达图缩放大小
        },
        series: [
          {
            name: 'Budget vs spending',
            type: 'radar',
            areaStyle: {},
            data: series
          }
        ]
      }

      if (option && typeof option === 'object') {
        myChart.setOption(option)
      }
      window.addEventListener('resize', myChart.resize)
    },
 getPhysicalStrength (legend, indicator, series) {
      const myChart = echarts.init(this.$refs.physicalStrength)
      const option = {
        title: {
          text: '运动体能数据综合分析',
          textStyle: {
            fontSize: 16,
            fontWeight: 500
          }
        },
        legend: {
          data: legend,
          left: 'right',
          top: 0,
          orient: 'vertical'
        },
        radar: {
          indicator: indicator,
          center: ['50%', '60%'],
          radius: 100 // 雷达图缩放大小
        },
        series: [
          {
            name: 'Budget vs spending',
            type: 'radar',
            areaStyle: {},
            data: series
          }
        ]
      }

      if (option && typeof option === 'object') {
        myChart.setOption(option)
      }

      window.addEventListener('resize', myChart.resize)
    },
 
   getStrongWeak (data) {
      const myChart = echarts.init(this.$refs.strongWeak)
      const option = {
        title: {
          text: '锻炼项目分占比',
          textStyle: {
            fontSize: 16,
            fontWeight: 500
          }
        },
        tooltip: {
          trigger: 'item'
        },
        
        legend: {
          left: 'right',
          top: 0,
          orient: 'vertical'
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['40%', '60%'],
                // radius: [51, 100],
            center: ['50%', '45%'],
            top:'10%',
            left: 0,
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              formatter: "{b}  ({d}%)",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold'
              }
            },
            // labelLine: {
            //   show: true
            // },
            data: data
          }
        ]
      }

      if (option && typeof option === 'object') {
        myChart.setOption(option)
      }

      window.addEventListener('resize', myChart.resize)
    },
     getStrongTime(data) {
      console.log('data',data);
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(this.$refs.strongTime)

        let option = {
            title: {
            text: '锻炼时间分布（学年）',
            textStyle: {
              fontSize: 14,
              fontWeight: 500
            }
          },
            tooltip: {
                trigger: 'item',
               formatter: "{b} : {c} ({d}%)"
            },
            legend: {
				        top:'14%',
                // data: ['15-18','13-15','12-13', '10-12','08-10',],
                data: ['傍晚','下午','中午', '上午','清晨',],
                icon: 'circle',
                textStyle: {
                    // color: 'rgba(255,255,255,.6)',
                    color: '000',
                }
            },
            calculable: true,
            series: [{
                name: '',
				color: ['#62c98d', '#2f89cf', '#4cb9cf', '#53b666', '#62c98d', '#205acf', '#c9c862', '#c98b62', '#c962b9','#c96262'],	
                type: 'pie',
                //起始角度，支持范围[0, 360]
                startAngle: 0,
                //饼图的半径，数组的第一项是内半径，第二项是外半径
                radius: [51, 70],
                //支持设置成百分比，设置成百分比时第一项是相对于容器宽度，第二项是相对于容器高度
                center: ['50%', '45%'],
                
                //是否展示成南丁格尔图，通过半径区分数据大小。可选择两种模式：
                // 'radius' 面积展现数据的百分比，半径展现数据的大小。
                //  'area' 所有扇区面积相同，仅通过半径展现数据大小
                roseType: 'area',
                //是否启用防止标签重叠策略，默认开启，圆环图这个例子中需要强制所有标签放在中心位置，可以将该值设为 false。
                avoidLabelOverlap: false,
                
                label: {
                    // normal: {
                    //     show: true,
                    // },
                    formatter: "{b}  ({d}%)",
                    // emphasis: {
                    //     show: true
                    // }
                },
                labelLine: {
                    normal: {
                        show: true,
                        length2: 1,
                    },
                    emphasis: {
                        show: true
                    }
                },
                data: [
				...data,
                    {value: 0, name: "",label: {show: false},labelLine: {show: false}},
                    {value: 0, name: "",label: {show: false},labelLine: {show: false}},
                    {value: 0, name: "",label: {show: false},labelLine: {show: false}},
                    {value: 0, name: "",label: {show: false},labelLine: {show: false}},
                    {value: 0, name: "",label: {show: false},labelLine: {show: false}},

                   
                ]
            }]
        };

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
        window.addEventListener("resize",function(){
            myChart.resize();
        });
    },
    selectStudentActivityList(){
      // this.loading =true
          selectStudentActivityList({
              snCode:this.data.snCode,
              projectCode:this.$route.query.projectCode,
              schoolCode:this.data.schoolCode,
              termCode:this.termCode,
              day:this.selectDay,
            }).then(res=>{
              console.log(res);
              // this.loading =false
              this.list = res.data.body || []
            })
      },
   init(){
    this.loading =true
   
    getWgzTest({
      snCode:this.data.snCode,
      schoolCode:this.data.schoolCode,
      termCode:this.termCode
    }).then(res=>{
      console.log(res);
      this.projectScoreList = res.data.data||[]
      this.loading =false
    })
 
      getWgzData({
      snCode:this.data.snCode,
      schoolCode:this.data.schoolCode,
      termCode:this.termCode
    }).then(res=>{
      console.log(res);
      const body = res.data.body
       const sportProjectCenter = res.data.body.sportProjectCenter || []
       sportProjectCenter?.forEach(el=>{
        el.name = el.projectName
        el.value = el.center
       })
//        center: 100
// count: 12
// hour: "9"
       const sportHourCenter = res.data.body.sportHourCenter.reverse()|| []
 
       sportHourCenter?.forEach(el=>{
        switch (el.hour) {
          case '08-10':el.name = '清晨'; break;
          case '10-12':el.name = '上午'; break;
          case '12-13':el.name = '中午'; break;
          case '13-15':el.name = '下午'; break;
          case '15-24':el.name = '傍晚'; break;
          default:
            break;
        }
        // el.name = el.hour
        el.value = el.center
       })


       
        // this.getStrongWeak(sportProjectCenter)
        // this.getStrongTime(sportHourCenter)
       this.finalScoreData = {sportTime:body.sportTime,sportCount:body.sportCount }||{}
    })
    
    getTopByCount({
      snCode:this.data.snCode,
      schoolCode:this.data.schoolCode,
      termCode:this.termCode
    }).then(res=>{
      this.TopByCount= res.data.body||0
      console.log('res',res);
      // this.finalScoreData = res.data.body||[]
    })





    // scoreStaBySnCode({
    //   snCode:this.data.snCode,
    //   schoolCode:this.data.schoolCode
    // }).then(res=>{
    //   this.finalScoreData = res.data.body||[]
    //   this.loading =false
    // })
    // getFitnessTestBySnCode({
    //   snCode:this.data.snCode,
    //   schoolCode:this.data.schoolCode
    // }).then(res=>{
    //   this.fitnessTestData = res.data.body||[]
    //   this.loading =false
    // })
  }
}
}
</script>
<style lang="less" scoped>
@font-face {
    font-family: DINPro-Bold;
   src: url(../../assets/font/DINPro-Bold.otf);
}
@font-face {
    font-family: DINPro-Medium;
   src: url(../../assets/font/DINPro-Medium.otf);
}
@font-face {
    font-family: douyuFont;
   src: url(../../assets/font/douyuFont.otf);
}
.page{
  height: 100vh;
  overflow-y: auto;
  background-image: url("../../assets/parentImg/finessBg.png");
  background-size: 100% 180%;
  background-repeat: no-repeat;
  padding: 4vw;
}

 .trend_box{
  height: 300px;
  background-color: #fff;
  border-radius: 15px;
  padding: 4vw;
  .trendtitle_box{
    margin-bottom: 15px;
  }
  .trendChart{
    height: 250px;
    width: 100%;
  }
}
.title_box{
  // height: 440px;
  .title{
    font-size: 20px;
    font-family: douyuFont;
    color: #fff;
    margin-top: 20px;
    margin-bottom: 60px;
    // text-align: center;
  }
 
  .cardRoll_box{
  position: relative;
  height: 418px;
  border-radius: 15px;
  margin-top: 20px;
  // background: radial-gradient(circle, skyblue, transparent);
  box-sizing: border-box;
     .cardRoll_badgetopbox{
        position: absolute;
        top: -40px;
        right: 4vw;
        width: 100px;
        height: 150px;
        z-index: 9999;
      }
    .cardRoll_topbox{
      height: calc(100px - 8vw);
      width: calc(100% - 8vw);
      padding: 4vw;
      background-color: rgb(255, 255, 255);
      border-radius: 15px 15px 0 0;
      box-shadow: 0px 3px 8px 0px rgba(0,0,0,0.04);
      -webkit-mask: radial-gradient(circle at 0 bottom, #0000 8px, red 0), radial-gradient(circle at right bottom, #0000 8px, red 0);
      -webkit-mask-size: 51% 100%;
      -webkit-mask-position: 0, 100%;
      -webkit-mask-repeat: no-repeat;
      .year_score{
        font-family: DINPro-Bold;
      }
   
    }
    .cardRoll_bottombox{
      position: relative;
      height: 315px;
      width: 100%;
      // padding: 4vw;
      background-color: rgb(255, 255, 255);
      border-radius: 0 0 15px 15px;
      box-shadow: 0rpx 3px 8px 0px rgba(0,0,0,0.04);
    -webkit-mask: radial-gradient(circle at 0 top, #0000 8px, red 0), radial-gradient(circle at right top, #0000 8px, red 0);
    -webkit-mask-size: 51% 100%;
    -webkit-mask-position: 0, 100%;
    -webkit-mask-repeat: no-repeat;
    .cardRoll_bottombox_card{
          height: calc(315px - 8vw);
      width: calc(100% - 8vw);
      // background-color: #cfcd3e;
      padding:4vw;
      .calendar-top-button{
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: flex-end;
        font-size: 14px;
      }
          /deep/ .green-flag{
        position: relative;
        z-index: 1;
        color: #fff;
      }
      /deep/.green-flag::before {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        line-height: 40px;
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        font-size: 15px;
        background-color: #00ce15;
        z-index: -1;
      }
      .green-flag .van-calendar-day__text {
      color: #1989fa; /* Vant 主题色文字 */
      font-weight: 500;
    }
       /deep/ .red-flag{
        background-color: red;
        width: 40px;
        height: 40px;
        border-radius: 50%;

      }
 ::v-deep .van-calendar__day{
        // width: 40px;
        // height: 40px;
      }
       ::v-deep .van-calendar__weekday{
        // width: 40px;
      }
      ::v-deep .van-calendar__selected-day{
        border-radius: 50%;
        background-color: #09c1f9;
      }
      ::v-deep .van-calendar__header{
          box-shadow:none;
      }
       ::v-deep .van-calendar__bottom-info {
        line-height: 0px;
      }
        ::v-deep .van-calendar__footer {
          display: none;
      }
      ::v-deep .van-calendar__month-title {
          display: none;
      }
      .cardRoll_bottombox_top{
        display: flex;
        justify-content: space-between;
        font-family: DINPro-Bold;
        font-size: 24px;
  text-align: center;
      .cardRoll_bottombox_topleft{
        width: 38vw;
        height: 19vw;
        line-height: 19vw;
         background-image: url("../../assets/parentImg/身高icon.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
      }
      .cardRoll_bottombox_topright{
        width: 38vw;
        height: 19vw;

        line-height: 19vw;
         background-image: url("../../assets/parentImg/体重icon.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;

      }
      }
      .cardRoll_bottombox_bottom{
        width: 100%;
        .cardRoll_bottombox_bottomtop{
          display: flex;
        justify-content: space-between;
        margin-top: 15px;
        font-family: DINPro-Bold;

        .cardRoll_bottombox_bottomtopright{
          display: flex;

          .cardRoll_bottombox_bottomtopright_text{
            width: 40px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            border-radius: 15px;
            font-size: 12px;
            background-color: #e1eef7;
            color: #2e8bd3;
            margin-left: 8px;
          }
        }
        }




   .test-item {
        background-color: rgb(239, 250, 255);
        margin: 4vw 0;
        padding: 15px;
        border-radius: 15px;
        .test-item-header{
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
    

        }
        .test-item-bottom{
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
          font-size: 12px;
          color: rgb(153, 153, 153);
        }
      }


.progress-container {
  height: 10px;
  background: #eee;
  border-radius: 10px;
  // margin: 10px 0;
}

.main-progress {
  height: 100%;
  border-radius: 10px;
  // position: relative;
}

.current-marker {
  // position: absolute;
  width: 3px;
  height: 100%;
  // background: #ff5722;
  // top: -15%;
  // transform: translateX(-50%);
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.reference-bar {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

.segment {
  flex: 1;
  text-align: center;
  position: relative;
}
.marker{
  height: 3px;
  width: 100%;
}
.segment::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 4px;
  width: 100%;
  // background: currentColor;
}

.label {
  display: block;
  font-size: 12px;
  color: rgb(137, 170, 183);
}




      }


    }
    .card-eachart{
      height: calc(250px - 8vw);
      width:100%;
    }
    }
    .line{
      width: calc(100% - 20px);
      border-bottom: 2px dotted #dbedf7;
      margin: 0 10px;
    }



  }
}
    .dfcenter{
    display: flex;
    align-content: center;
    align-items: center;
    font-size: 14px;
  }

  .year_status_topbox{
  display: inline-block;
  width: 60px;
  height: 22px;
  line-height: 22px;
  background: #2973db48;
  border-radius: 10px;
  text-align: center;
  margin-left: 8px;
  font-size: 3vw;
  color: #000;
  // opacity: 0.3;


}
.yearbox{
position: relative;
min-height: 440px;
// margin: 10px;
padding: 4vw;
border-radius: 10px;
// background-image: url('../../assets/image/ticeTitle.png');
// background-size: 100% 100%;
// background-repeat: no-repeat, repeat;
background-color: #fff;
color: #fff;
letter-spacing:1.5px;
box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
.isStatusClass{
  position: absolute;
}
.year_title{
  font-size: 5.5vw;
  margin-bottom: 10px;
  color: #000;
}
.year_center{
      font-size:3.5vw;  
    // color: #000;
    // text-align: right;
  
}

.year_zonghe{
  color: #000;
  font-size: 5vw;
  font-weight: 500;
  margin-bottom: 10px;
}
.year_score{
margin-bottom: 10px;
}
.year_status{
  display: inline-block;
  width: 60px;
  height: 22px;
  line-height: 22px;
  background: #2972DB;
  border-radius: 10px;
  text-align: center;
  margin-left: 8px;
  font-size: 3vw;
  opacity: 0.3;

}
}
.projectBox{
  .project_li{
    background-color: #fff;
    border-radius: 15px;
    margin: 15px 0;
    box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
    padding: 4vw;
    
  }
  .project_box{
    display: flex;
    align-items: center;
  }
  .project_title{
    font-size: 4.1vw;  
    font-weight: 600;
    color: #000;
  }
  .project_time{
    font-size: 2.8vw;  
    color: #000;
    text-align: right;

  }
  .levelBox{
      position: absolute;
      top: -16px;
      left: 0;
      width: 9vw;
    }
  .project_score{
    display: flex;
    margin: 20px 0 30px 0;
    
    .project_score_li{
      width: 40%;
      text-align: center;
    }
    .project_score_li_top{
    font-size: 5.5vw;  
    font-weight: 700;
    margin-bottom: 10px;
    color: #3D3D3D;
    }
    .project_score_li_bottom{
    color: #d3cccc;
    font-size: 3vw;
    }
    
  }
  .noproject_score{
    color: #bbb;
    text-align: center;
    // height: 50px;
    // line-height: 50px;
    margin: 20px 0 30px 0;
  }
  .project_video{
    font-size: 13px;
    display: flex;
    justify-content: space-between;
  }
  .dfcenter{
    display: flex;
    align-content: center;
    align-items: center;
  }

}
 .card {
    margin: 15px 0; 
    padding: 4vw;
    border-radius: 15px;
    background: #ffffff;

    .switch-box {
      margin: 20px auto;
      display: flex;
      justify-content: space-between;
      border: 1px solid #23B1FB;
      align-items: center;
      width: 40%;
      height: 30px;
      font-size: 13px;
      color: #23B1FB;
      border-radius: 30px;
      overflow: hidden;

      div {
        width: 50%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 30px;
      }

      div.active {
        background: #23B1FB;
        color: #ffffff;
      }
    }

    .card-table {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-flow: wrap;
      font-size: 14px;

      .card-td {
        margin-bottom: 20px;
        width: 50%;
        text-align: center;
      }

      .card-td-num {
        font-size: 32px;
      }

      .card-td-sub {
      
        color: #868686;
      }
    }

    .card-eachart {
      width: 100%;
      height: 250px;
    }
    .card-img{
      width: 100%;

    }
    .tishengbox{
      .listbox{
    display: flex;
    margin-bottom: 40px;
  }
 
  .title{
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    letter-spacing: 5px;
    text-align: center;
  }
    }

  }

  .menu{
  font-size: 13px;
  .menu_down{
    text-align: center;
    margin: 10px;


 .center{
        height: 118px;
        line-height: 118px;
        text-align: center;
        position: relative;
        // background-color: #fff;
        // border-radius:10px;
        margin-top: 16px;
        box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
        object-fit: cover;
        .center_text{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            font-size: 20px;
            font-weight: 700;
            color: #458ff1b9;
        }
        .center_value{
            color: #bbb;
        }
    }


  }
 .menu_row{
    text-align: center;
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-items: center;
   text-align: center;
   
   .menu_li{
    margin: 10px auto;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
   }

 } 

}
.appeal-list {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  &-warp {
    // flex: 1;
    border-radius: 15px;

    padding: 4vw;
    background-color: #fff;
    // border-radius: 10px;
    // margin: 10px;
  .mileagebox{
      display: flex;
      align-items: baseline;
      margin-top: 10px;
    }
    .mileageStyle{
      width: 100%;
      height: 38px;
      line-height: 38px;
      font-size: 28px;
      font-family: DINPro-Bold;
      overflow: hidden;
      white-space: nowrap;      /* 不换行 */

    }
    .item {
      margin-top: 15px;

  .item-li{
    display: flex;

    .item-li-left{
      // position: relative;
      // width: 20%;
      // text-align: center;
      // margin: auto;

      position: relative;
  width: 20%;
  text-align: center;
  margin: auto;
  min-height: 56px; /* 根据实际高度调整 */
    font-family: DINPro-Medium;

    }
    .timeline-line {
      position: absolute;
      left: 50%;
      top: 45px;
      width: 1px;
      height: 80%;
      background: #e0e0e079;
      transform: translateX(-50%);
      z-index: 0;
    }
    .item-li-right{
      // background: linear-gradient(147deg, #DAFF8D 0%, #DAFF8D 100%);
      // background: #fff;
      // box-shadow: 0px 1px 6px 0px #eef1fc;
      border-radius: 10px;
      padding: 12px;
      width: 70%;
      display: flex;
      flex-direction: column;
      position: relative;
      text-align: center;

      .item-li-right-goal{
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 16px;
        font-weight: 500;
        font-family: DINPro-Regular;
      }
    }
    .item-li-righta{
      background-image: url('../../assets/background/indexli.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      color: #fff;
    }
    .item-li-rightb{
      // background-image: url('../../assets/background/indexliv2.png');
      // background-size: 100% 100%;
      // background-repeat: no-repeat;


  //     border-radius: 40rpx;
  // background-color: rgb(246, 246, 246);
  // box-shadow: inset 0.07px 1.999px 3px 0px rgba(162, 162, 162, 0.67);
  // width: 828rpx;
  // height: 260rpx;

    background-image: -moz-linear-gradient( 90deg, rgb(1,94,234) 0%, rgb(0,192,250) 100%);
  background-image: -webkit-linear-gradient( 90deg, rgb(1,94,234) 0%, rgb(0,192,250) 100%);
  background-image: -ms-linear-gradient( 90deg, rgb(1,94,234) 0%, rgb(0,192,250) 100%);
  border-radius: 15px;
  width: 68.5vw;
  height: 56px;
    color: #fff;






    }
  }


      .right {
          font-size: 16px;
          font-weight: 500;
        
          &.bg0 {
            // background: #ffecde;
            color: #ff5600;
            
          }
          &.bg1 {
            // background: #e4f2ff;
            color: #007ff0;
          }
          &.bg2 {
            // background: #e4f2ff;
            color: #007ff0;
          }
          &.bg3 {
            // background: #ffe9eb;
            color: #ff0000;
          }
        }
    }
  }
  .footer {
    display: flex;
    margin-bottom: 3%;
    margin-top: 5%;
    justify-content: space-around;
    /deep/.van-button {
        
      flex-basis: 80%;
      
    }
  }
}
</style>
